import React from "react";
import ReactDOM from "react-dom";
import { RootRoute } from "@app/const";
import { navigateToRoute } from "./functions";

function formatTime(lastTime){
    const diff = window.apm.timestamp - lastTime;
    if (diff < 60000){
        return "a few seconds ago";
    } else if (diff < 120000){
        return "1 minute ago";
    } else if (diff < 3600000){
        return Math.round(diff / 60000) + " minutes ago";
    } else {
        return "over an hour ago";
    }
}

export default class Notification {
    /**
     * Notification handler
     * @module Notification
     */
    constructor(){
        this.notificationHistory = [];
        this.timeWorker = null;
    }

    /**
     * Post a notification message.
     *
     * @param {string} toastType Message type.
     * @param {unkown} toastText Message text (typed as unkown for catch errors).
     */
    post(toastType, toastText, autoHide = true, onclick = null){
        if (typeof toastText !== 'string') {
            return;
        }
        const timeOut = (autoHide) ? 3000 : 0;
        const extendedTimeOut = (autoHide) ? 1000 : 0;
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-top-center",
            "preventDuplicates": true,
            "onclick": null,
            "showDuration": "200",
            "hideDuration": "100",
            "timeOut": timeOut,
            "extendedTimeOut": extendedTimeOut,
            "showEasing": "linear",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }
        //this is implemented to open settings when clicked on exception handling notification error
        if(onclick){
            toastr.options.onclick = function() { 
                navigateToRoute(RootRoute.settings);
            }
        }
        toastr[toastType](toastText);
        this.notificationHistory.push({
            text: toastText,
            type: toastType,
            time: window.apm.timestamp
        });
        $("#bottom-notification-text").html(
            "<span class='notification-time'>(now)</span>" +
            toastText
        );
        if (this.timeWorker === null){
            this.timeWorker = setInterval(this.checkTime.bind(this), 10000);
        }
    }

    /**
     * Update notification time text
     */
    checkTime(){
        if (this.notificationHistory.length <= 0){
            return;
        }
        const lastNote = this.notificationHistory[this.notificationHistory.length - 1];
        const timeString = formatTime(lastNote.time);
        $("#bottom-notification-text").children(".notification-time").html("(" + timeString + ")");
    }

    /**
     * Render notification history list to the dialog
     * @returns {string} HTML markup
     */
    getView(){
        const tmp = $("<div class='notification-log'></div>");
        ReactDOM.render(<NotificationView history={this.notificationHistory} />, tmp.get(0));
        return tmp.html();
    }
}

class NotificationView extends React.Component {
    render(){
        var rows = [];
        for (var i = this.props.history.length - 1; i >= 0; i--){
            rows.push(<NotificationViewRow rowData={this.props.history[i]} key={i} />);
        }
        return (
            <ul
                style={{
                    listStyle: "none",
                    textAlign: "left",
                    paddingLeft: "12px"
                }}
            >{rows}</ul>
        );
    }
}

class NotificationViewRow extends React.Component {
    render(){
        return (
            <li className="notification-list">
                <div className="time">
                    <div className={"notification-indicator " + this.props.rowData.type}></div>
                    <div style={{display:"inline-block"}}>{formatTime(this.props.rowData.time)}</div>
                </div>
                <div>{this.props.rowData.text}</div>
            </li>
        );
    }
}